<template>
    <nav>
      <router-link to="/admin/home">Home</router-link>
      <router-link to="/admin/setting">Setting</router-link>
    </nav>
</template>
<script>
export default {
  name: 'AdminNav',
}
</script>


// WEBPACK FOOTER //
// src/components/AdminNav.vue